import {redirect} from 'react-router-dom';

import {getCurrentUser} from '@/services/authService';

export const loginLoader = async () => {
  const user = await getCurrentUser();
  if (user) return redirect('/');

  return null;
};
